import React, { useState, useEffect } from 'react';
import MarginHeader from './marginHeader';
const headerStyle = {
    backgroundColor: '#004080',
    color: '#fff',
    fontSize: '14px',
    fontFamily: 'Roboto Regular',
    fontWeight: 'normal',
    borderRight: '1px solid rgb(255 255 255 / 50%)',
    verticalAlign: 'middle',
    textAlign: 'center',
};

const tdStyle = {
    background: '#f5f5f5',
    borderBottom: '1px solid #ccc',
    borderRight: '1px solid rgb(255 255 255 / 50%)',
    padding: '5px 10px',
    color: '#333',
    fontSize: '12px',
};

const totalRowStyle = {
    background: '#fff',
    color: '#000',
    fontWeight: 'bold',
    textAlign: 'right',
    fontSize: '12px',
    padding: '10px',
};

const footerStyle = {
    borderTop: '2px solid #d5d5d5',
    textAlign: 'center',
    fontSize: '12px',
    padding: '10px 0',
    margin: 0,
};

const formatAmount = (amount) => {
    const formattedAmount = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(amount)) || 0);
    return Number(amount) < 0 ? `(${formattedAmount})` : formattedAmount;
};
const formatAmountSixdigitDecimal = (amount) => {
    const formattedAmount = new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Math.abs(Number(amount)) || 0);
    return Number(amount) < 0 ? `(${formattedAmount})` : formattedAmount;
};

const MarginTable = ({ marginDetails, clientAddressDetails, fromDate, toDate }) => {
    const [tableData, setTableData] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(11); // Adjust this if necessary

    useEffect(() => {
        const generateTableData = () => {
            const rows = [];
            marginDetails?.forEach((item) => {
                const { currencydesc, items, totalInvestmentCost, totalMarketValue, totalUnrealizedGainLoss } = item;

                rows.push({ currencydesc, isCurrencyRow: true });
                items.forEach((transaction) => {
                    rows.push(transaction);
                });
                rows.push({
                    comments: 'TOTAL',
                    totalInvestmentCost: parseFloat(totalInvestmentCost).toFixed(2),
                    totalMarketValue: parseFloat(totalMarketValue).toFixed(2),
                    totalUnrealizedGainLoss: parseFloat(totalUnrealizedGainLoss).toFixed(2),
                });
            });

            setTableData(rows);
        };

        generateTableData();
    }, [marginDetails]);

    const paginateTableData = (data, rowsPerPage) => {
        const paginatedData = [];
        for (let i = 0; i < data.length; i += rowsPerPage) {
            const page = data.slice(i, i + rowsPerPage);
            // Keep pages with actual data rows or summary rows, but skip header-only slices.
            const hasVisibleRows = page.some(
                (row) => row && (row.securityName || row.comments === 'TOTAL')
            );
            if (hasVisibleRows) {
                paginatedData.push(page);
            }
        }
        return paginatedData;
    };

    const paginatedTableData = paginateTableData(tableData, rowsPerPage);

    return (

        <div>
            {paginatedTableData.map((page, pageIndex) => {
                const hasContent = page.length > 0;
                return (
                    <div
                        key={pageIndex}
                        style={{
                            pageBreakAfter: pageIndex < paginatedTableData.length - 1 ? 'always' : 'auto',
                            pageBreakInside: 'avoid',
                            padding: '0',
                            margin: '0',
                        }}
                    >
                        <header>
                            <MarginHeader clientAddressDetails={clientAddressDetails} fromDate={fromDate}
                                toDate={toDate} />
                        </header>
                        <hr />
                        <main style={{ minHeight: '440px', pageBreakInside: 'avoid', padding: '0' }}>
                            <table
                                className="table"
                                style={{
                                    width: '100%',
                                    borderCollapse: 'collapse',
                                    pageBreakInside: 'avoid',
                                }}
                            >
                                <thead>
                                    <tr style={headerStyle}>
                                        <th style={{ ...headerStyle, width: '30%' }}>Security Name</th>
                                        <th style={{ ...headerStyle, width: '10%' }}>Quantity</th>
                                        <th style={{ ...headerStyle, width: '10%' }}>Average Price</th>
                                        <th style={{ ...headerStyle, width: '20%' }}>Market Price</th>
                                        <th style={{ ...headerStyle, width: '10%' }}>Investment Cost</th>
                                        <th style={{ ...headerStyle, width: '10%' }}>Market Value</th>
                                        <th style={{ ...headerStyle, width: '10%' }}>Unrealized Gain/(Loss)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {page.map((row, index) => (
                                        <React.Fragment key={index}>
                                            {row.isCurrencyRow ? (
                                                <tr style={{ backgroundColor: '#e7f3fe' }}>
                                                    <td colSpan={7} className="td-colors bg-white border-0 table-split-head moble-thead-change">
                                                        {row.currencydesc}
                                                    </td>
                                                </tr>
                                            ) : row.comments === 'TOTAL' ? (
                                                <tr style={{ borderBottom: '1px solid #fff', background: '#d9edf7' }}>
                                                    <td style={totalRowStyle} colSpan={4}>Total</td>
                                                    <td style={{ ...totalRowStyle, borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                                                        <span style={{ color: Number(row.totalInvestmentCost) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.totalInvestmentCost)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...totalRowStyle, borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                                                        <span style={{ color: Number(row.totalMarketValue) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.totalMarketValue)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...totalRowStyle, borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                                                        <span style={{ color: Number(row.totalUnrealizedGainLoss) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.totalUnrealizedGainLoss)}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ) : (
                                                <tr >
                                                    <td style={tdStyle}>{row.securityName}</td>
                                                    {/* <td style={tdStyle}>{row.valueDate}</td>
                                                    <td style={tdStyle}>{row.comments}</td> */}
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.quantity) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.quantity)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.avgPrice) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmountSixdigitDecimal(row.avgPrice)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.marketPrice) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmountSixdigitDecimal(row.marketPrice)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.investmentCost) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.investmentCost)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.marketValue) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.marketValue)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.unrealizedgainloss) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.unrealizedgainloss)}
                                                        </span>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </main>
                        {hasContent && (
                            <footer style={footerStyle}>
                                <div>A Subsidiary of DUBAI INVESTMENTS</div>
                                <div>
                                    {clientAddressDetails.building}, {clientAddressDetails.street}, {clientAddressDetails.citya}, {clientAddressDetails.countrya}.
                                    Office {clientAddressDetails.officeno}, P.O. Box-{clientAddressDetails.postbox}, Tel: {clientAddressDetails.mobile},
                                </div>
                                <div>Al Mal Capital PSC is incorporated in Dubai UAE under CR 76761 as a Private Joint Stock Company with a paid-up share capital of AED 219.78 Million</div>
                                <div>(Al Mal Capital PSC is licensed and regulated by the Securities and Commodities Authorities, License No# 603022)</div>
                            </footer>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default MarginTable;
